import React from 'react'
import RoomSchedule from 'frontend/schedule/room-schedule'
import PlayersCountButtons from 'frontend/schedule/players-count-buttons'
import PlayersCountInput from 'frontend/schedule/players-count-input'
import MinPriceIndicator from 'frontend/schedule/min-price-indicator'
import RoomWeekSelect from 'frontend/schedule/room-week-select'
import CommonIcons from 'frontend/components/common-icons'

export default class HoudiniSchedule extends RoomSchedule {
  renderFilters () {
    return (
      <div className="filters">
        <div className="select_players_count">
          <h4 className="title">
            <span className="fix_title">1. Select number of players</span>
          </h4>
          <p className="note">
            This room is optimal to play with 3-5 people. Minimum booking is for 3 people. You are
            welcome to play with 2 people but the price will be as a 3 person booking
          </p>
          <PlayersCountButtons
            playersWithMinPrices={this.state.schedule.minPriceByPlayersCount}
            selected={this.state.selectedPlayersCount}
            onSelect={this.handlePlayersCountSelect.bind(this)}
          />
          <div className="players_count_input_with_price_indicator">
            <PlayersCountInput
              minPlayers={this.state.schedule.minPlayers}
              maxPlayers={this.state.schedule.maxPlayers}
              value={this.state.selectedPlayersCount}
              onChange={this.handlePlayersCountSelect.bind(this)}
            />
            <MinPriceIndicator
              playersCount={this.state.selectedPlayersCount}
              playersWithMinPrices={this.state.schedule.minPriceByPlayersCount}
            />
          </div>
        </div>
        <div className="select_date">
          <h4 className="title">
            <span className="fix_title">2. Select date and time</span>
          </h4>
          <RoomWeekSelect
            selected={this.state.selectedDate}
            onChange={this.handleDateSelect.bind(this)}
          />
        </div>
      </div>
    )
  }

  renderHelpers () {
    return (
      <div className="helpers">
        <div className="eye_legend helper">
          <CommonIcons item="common-eye-r" className="icon" />
          Click on booked game <span className="color_text">(eye icon)</span>
          <br /> to see more options
        </div>
        <div className="legend_with_calendar helper">
          <div className="blue_price">
            <CommonIcons item="common-calendar-alt-r" className="icon" />
            <div className="type_label">Monday - Thursday:</div>
            <div className="price_label">starting&nbsp;at $43 per/person</div>
          </div>
          <div className="green_price">
            <CommonIcons item="common-calendar-alt-r" className="icon" />
            <div className="type_label">Friday - Sunday:</div>
            <div className="price_label">starting&nbsp;at $47 per/person</div>
          </div>
        </div>
      </div>
    )
  }
}
